import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../view/Login'
import Register from '../view/Register'
import Home from '../view/Home'
// 安装路由
Vue.use(VueRouter);

const router = new VueRouter({
  routes: [{
    path: "/",
    redirect: "/login"
  },
  {
    name: "Login",
    path: '/login',
    component: Login
  },
  {
    name: "Register",
    path: '/register',
    component: Register
  },
  {
    name: "Home",
    path: '/home',
    component: Home,
    meta: { requiresAuth: true },
    children: [
      {
        name: "Statistics",
        path: "/home/statistics",
        component: () => import("../view/Statistics"),
      },
      {
        name: "Chat",
        path: "/home/chat",
        component: () => import("../view/Chat"),
      },
      {
        name: "Friend",
        path: "/home/friend",
        component: () => import("../view/Friend"),
      },
      {
        name: "GROUP",
        path: "/home/group",
        component: () => import("../view/Group"),
      }
    ]
  }
  ]
});

// 路由守卫：未认证用户重定向到登录页
router.beforeEach((to, from, next) => {
  const accessToken = sessionStorage.getItem('accessToken');
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!accessToken) {
      next({ path: '/login' });
    } else {
      next();
    }
  } else {
    // 已登录用户访问登录页时重定向到聊天页
    if (accessToken && (to.path === '/login' || to.path === '/register')) {
      next({ path: '/home/chat' });
    } else {
      next();
    }
  }
});

export default router;
